import type { FaireProductEntity } from "../../entity_types/product";

export const p_qamhtee5xe: FaireProductEntity = {
  token: "p_qamhtee5xe",
  type: "product",
  name: "Instant - Single Origin Variety Pack",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/46ad9ffb02791e1b1d0ec8e755b29b4ae247d554fd414590a209a30479813b07.jpeg",
  galleryImageUrls: [],
  priceDollars: 14,
  description: "Just add hot water and you can make some delicious decaf coffee while traveling, on the go, or even at home!\n\nPack of 6 various single origin packets in a lovely box.\n\nYou're don't need to compromise flavor to have coffee on the go.\nThis instant coffee is made from our perfectly roasted single origin beans and processed by Swift Coffee to ensure a wonderful and delicious cup every time.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:08.565Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
